export const FLAME_COLOR = "var(--kcal-flame)";

// Harmonized vertical reservation for the floating energy banner over
// scrollable cart/summary content. Single source — bump here if the banner
// itself grows.
//
// Derivation (empirical, measured on the kiosk 1080p reference layout):
//   padding-top(26) + padding-bottom(26) + line-height(~60) + margin(~28)
//   ≈ 140 → ENERGY_BANNER_PADDING_BOTTOM
//   ENERGY_BANNER_MIN_HEIGHT = 2 × ENERGY_BANNER_PADDING_BOTTOM (room for the
//   tall variant with the footnote on two lines).
// Re-measure on resolution change and update both values in sync.
export const ENERGY_BANNER_PADDING_BOTTOM = 140;
export const ENERGY_BANNER_MIN_HEIGHT = 280;
